module.exports = __webpack_public_path__ + "img/arrow_down.36c10fef-74a57df6.fd87aa9a.svg";